import { render, staticRenderFns } from "./EsgSingleScoreCard.vue?vue&type=template&id=220322d3&scoped=true"
import script from "./EsgSingleScoreCard.vue?vue&type=script&lang=js"
export * from "./EsgSingleScoreCard.vue?vue&type=script&lang=js"
import style0 from "./EsgSingleScoreCard.vue?vue&type=style&index=0&id=220322d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220322d3",
  null
  
)

export default component.exports